export class Variable {
  public id: string;
  public targetKey: string;
  public fieldKey: string;
  public type: string;
  public gridFieldKey: string;
  public gridFieldType: string;
  public jsonPath: string;
  public determinantId: string;
}
